import { render, staticRenderFns } from "./recordWithdrawalsAccountsOperations.vue?vue&type=template&id=624df707&"
import script from "./recordWithdrawalsAccountsOperations.vue?vue&type=script&lang=js&"
export * from "./recordWithdrawalsAccountsOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports